const CASING = Object.freeze({
  upper: 'upper-case',
  lower: 'lower-case',
  ignore: 'ignore-case',
  sensitive: 'use-case',
});

// noinspection JSUnusedGlobalSymbols
export default CASING;
